import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";
import { API } from "@/App";

export const AdminRecoveryDialog = ({ open, onOpenChange, onRecovered }) => {
  const [email, setEmail] = useState("");
  const [setupKey, setSetupKey] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      let response;
      try {
        response = await axios.post(`${API}/admin/setup`, { email, setup_key: setupKey });
      } catch (setupError) {
        if (setupError.response?.status === 400) {
          response = await axios.post(`${API}/admin/recover`, { email, setup_key: setupKey });
        } else {
          throw setupError;
        }
      }
      toast.success(response.data.message);
      onRecovered(response.data.email, response.data.password || "");
      onOpenChange(false);
    } catch (error) {
      toast.error(error.response?.data?.detail || "Recovery failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-slate-900 border-slate-800" data-testid="admin-recovery-dialog">
        <DialogHeader>
          <DialogTitle className="text-white flex items-center gap-2">
            <KeyRound className="w-5 h-5 text-violet-400" /> Admin Account Recovery
          </DialogTitle>
          <DialogDescription className="text-slate-400">
            Enter the super-admin email and the server setup key. A temporary password will be emailed to the administrator.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label className="text-slate-300">Super-admin email</Label>
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-default" data-testid="recovery-email-input" />
          </div>
          <div className="space-y-2">
            <Label className="text-slate-300">Setup key</Label>
            <Input type="password" required value={setupKey} onChange={(e) => setSetupKey(e.target.value)} className="input-default" data-testid="recovery-key-input" />
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" className="btn-secondary" onClick={() => onOpenChange(false)} data-testid="recovery-cancel-btn">Cancel</Button>
            <Button type="submit" className="bg-violet-600 hover:bg-violet-500 text-white" disabled={loading} data-testid="recovery-submit-btn">
              {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />} Recover account
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
